import { createFileRoute } from "@tanstack/react-router";
import { Container } from "@mui/material";
import { useState } from "react";
import {
  UpdateProductionJobModal,
  RFIDTagHistoryAndMoveModal,
} from "@dmca/frontend/widgets/rfid";
import {
  JobsTableHeader,
  JobsTable,
  SelectionModal,
  WorkOrderHistoryModal,
} from "@dmca/frontend/widgets/production";
import { IProductionJobWithLocation } from "@dmca/models/interface/production-job";
import { useTRPC } from "@dmca/frontend/trpc";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  checkPermissionsInLoader,
  useSubscription,
} from "@dmca/frontend/hooks";
import { PageHeader } from "@dmca/frontend/components/nav";

export const Route = createFileRoute("/_authed/JobOverview")({
  component: JobsPage,
  loader: async ({ context }) =>
    await checkPermissionsInLoader("ProductionJob::ViewJobOverview", context),
  head: () => ({
    meta: [
      {
        title: "Jobs Overview | DNA Dashboard",
      },
    ],
  }),
});

function JobsPage() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  useSubscription("onProductionJobUpdate", () => {
    qc.invalidateQueries(trpc.productionJob.pathFilter());
  });
  useSubscription("onTagLocationUpdate", () => {
    qc.invalidateQueries(trpc.productionJob.pathFilter());
  });
  const [showRowSelectionModal, setShowRowSelectionModal] = useState(false);
  const [currentModal, setCurrentModal] = useState<
    "UpdateWorkOrder" | "RFIDUtils" | "WorkHistory"
  >();
  const [selectedJob, setSelectedJob] = useState<IProductionJobWithLocation>();

  const { data: cells } = useQuery(trpc.cell.getAll.queryOptions());

  return (
    <Container>
      <PageHeader>Jobs Overview</PageHeader>
      <JobsTableHeader />
      <JobsTable
        onRowClick={(row) => {
          setSelectedJob(row);
          setShowRowSelectionModal(true);
        }}
      />
      <SelectionModal
        showWorkHistory
        open={showRowSelectionModal}
        onClose={() => setShowRowSelectionModal(false)}
        onSelect={(option) => {
          setShowRowSelectionModal(false);
          setCurrentModal(option);
        }}
      />
      {selectedJob && (
        <>
          <UpdateProductionJobModal
            open={currentModal === "UpdateWorkOrder"}
            onClose={() => {
              setCurrentModal(undefined);
              setSelectedJob(undefined);
            }}
            job={selectedJob}
            cells={cells ?? []}
          />
          <RFIDTagHistoryAndMoveModal
            open={currentModal === "RFIDUtils"}
            onClose={() => setCurrentModal(undefined)}
            id={"0" + selectedJob.id}
          />
          <WorkOrderHistoryModal
            open={currentModal === "WorkHistory"}
            onClose={() => setCurrentModal(undefined)}
            jobId={selectedJob.id}
          />
        </>
      )}
    </Container>
  );
}
